import styled from 'styled-components';

import {
  SkeletonBodyCopy,
  SkeletonHeadline,
  SkeletonPillShape,
} from '@xing-com/skeleton';
import { spaceS, scale100 } from '@xing-com/tokens';

const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;

const TagsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spaceS};
`;

export const MatchingSkillsSkeleton: React.FC = () => (
  <SkeletonWrapper>
    <SkeletonHeadline amountRows={1} size="small" sizeConfined="medium" />
    <SkeletonBodyCopy amountRows={2} />
    <TagsWrapper>
      <SkeletonPillShape height={scale100} width="150px" />
      <SkeletonPillShape height={scale100} width="120px" />
      <SkeletonPillShape height={scale100} width="200px" />
    </TagsWrapper>
  </SkeletonWrapper>
);
